<div *ngIf="viewStatus == ViewStatus.READY">
  <div class="review-section">

    <swiper-container #mySwiper [centeredSlider]="true" [loopFillGroupWithBlank]="true" mousewheel-force-to-axis="true"
      style="width:100%;" [breakpoints]="{
      '0':   { slidesPerView: 1.2, spaceBetween: 10, slidesOffsetAfter: 20 },
      '400': { slidesPerView: 1.7, spaceBetween: 10, slidesOffsetAfter: 20 },
      '768': { slidesPerView: 2.5,   spaceBetween: 10, slidesOffsetAfter: 20 },
      '992': { slidesPerView: 3,   spaceBetween: 10, slidesOffsetAfter: 50 },
      '1200':{ slidesPerView: 3,   spaceBetween: 10, slidesOffsetAfter: 60 }}">

      <swiper-slide *ngFor="let review of reviews" [ngClass]="isNextDisabled ? 'extraMargin' : ''">
        <app-review [review]="review" (click)="reviewDetails(review)" class="pointer w-100"
          [quotation]="true"></app-review>
      </swiper-slide>
    </swiper-container>


    <div class="d-flex flex-row w-100 justify-content-between mt-2 container-xl container-fluid">
      <div class="show-button">
        <app-button [outlined]="true" size="sm" (click)="openReviewsOffcanvas()"
          label="{{'See all reviews' | translate}}"></app-button>
      </div>
    </div>
  </div>
  <div class="d-flex flex-row justify-content-between buttons"
    *ngIf="reviews && reviews.length > (swiperRef?.nativeElement?.swiper?.params?.slidesPerView || 1)">
    <button (click)="prev()" class="custom-arrow prev" [class.disabled]="isPrevDisabled">‹</button>
    <button (click)="next()" class="custom-arrow next" [class.disabled]="isNextDisabled">›</button>
  </div>
</div>

<ng-container *ngIf="viewStatus === ViewStatus.LOADING">

  <div class="d-flex justify-content-end mb-4">
    <div class="placeholder-btn-sm rounded-pill w-25"></div>
  </div>

  <ng-container *ngIf="viewStatus === ViewStatus.LOADING">

    <div class="swiper-skeleton-container d-flex overflow-hidden gap-3">

      <div class="card shadow-sm swiper-skeleton-card" *ngFor="let i of [1,2,3]" style="min-width: 280px;">
        <div class="card-body d-flex flex-column gap-3">

          <div class="d-flex justify-content-between align-items-center">

            <div class="d-flex flex-row align-items-center gap-2" style="flex: 1;">
              <app-shimmer-loader size="30px" shape="circle">
              </app-shimmer-loader>

              <div class="d-flex flex-column gap-2" style="flex: 1;">
                <app-shimmer-loader height="14px" width="35%"></app-shimmer-loader>
                <app-shimmer-loader height="12px" width="25%"></app-shimmer-loader>
              </div>
            </div>

            <app-shimmer-loader height="25px" width="40px"></app-shimmer-loader>
          </div>

          <div class="d-flex flex-column gap-2">
            <app-shimmer-loader height="14px" width="100%"></app-shimmer-loader>
            <app-shimmer-loader height="14px" width="85%"></app-shimmer-loader>
            <app-shimmer-loader height="14px" width="40%"></app-shimmer-loader>
          </div>

        </div>
      </div>

    </div>

  </ng-container>